import { render, staticRenderFns } from "./refundorderlist.vue?vue&type=template&id=1b4951e6&scoped=true"
import script from "./refundorderlist.vue?vue&type=script&lang=js"
export * from "./refundorderlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4951e6",
  null
  
)

export default component.exports